"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_LOCAL_STORAGE = void 0;
exports.USER_LOCAL_STORAGE = "user_local_storage";
